export enum EscrowFees {
  BuyerProtection = 'buyer_protection',
  ItemVerification = 'item_verification',
  Shipping = 'shipping',
  ElectronicsVerification = 'electronics_verification',
  Note = 'note',
}
